// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck TODO migrate RedirectToTracking
import type { ComponentType } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import { RedirectToTracking } from 'components/RedirectToTracking/RedirectToTracking';
import { SpinnerOverlay } from 'components/SpinnerOverlay/SpinnerOverlay';
import { hasOrder, hasPayment, isPaymentProcess } from 'selectors';
import { useTranslations } from 'utils';
import { getDisplayName } from 'utils/getDisplayName/getDisplayName';

const FIVE_SECONDS_IN_MS = 5000;

const WithPaymentCompletedRedirectionHOC = <P extends Record<string, unknown>>(
  WrappedComponent: ComponentType<P>,
) => {
  const WithPaymentCompletedRedirection = (props: P) => {
    const i18n = useTranslations();

    const isInPaymentProcess = useSelector(isPaymentProcess);
    const orderExists = useSelector(hasOrder);
    const paymentExists = useSelector(hasPayment);
    const isPaymentCompleted = paymentExists && orderExists;
    const shouldRedirectToTracking = isPaymentCompleted && isInPaymentProcess;

    if (!shouldRedirectToTracking) {
      return <WrappedComponent {...props} />;
    }

    return (
      <SpinnerOverlay
        message={i18n.t(
          'paymentInformation.paymentAlreadyCompletedRedirection.message',
        )}
        className="SpinnerOverlay-transparent"
      >
        <RedirectToTracking delay={FIVE_SECONDS_IN_MS} />
      </SpinnerOverlay>
    );
  };

  WithPaymentCompletedRedirection.displayName = `WithPaymentCompletedRedirection(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithPaymentCompletedRedirection;
};

export {
  WithPaymentCompletedRedirectionHOC as WithPaymentCompletedRedirection,
};
